
import CampaignHero from './components/CampaignHero';
import PriceContext from './components/PriceContext';
import CampaignBenefits from './components/CampaignBenefits';
import CampaignProducts from './components/CampaignProducts';
import CampaignCTA from './components/CampaignCTA';
import CampaignNotes from './components/CampaignNotes';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function CampaignPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CampaignHero />
      <PriceContext />
      <CampaignBenefits />
      <CampaignProducts />
      <CampaignCTA />
      <CampaignNotes />
      <Footer />
    </div>
  );
}
